<script lang="ts">
</script>

<footer class="et-l et-l--footer">
    <div class="et_builder_inner_content et_pb_gutters3">
        <div class="et_pb_section et_pb_section_0_tb_footer et_pb_with_background et_section_regular et_pb_section--with-menu">
            <div class="et_pb_row et_pb_row_0_tb_footer et_pb_row--with-menu et_pb_row_4col" style="z-index: 3;">
                <div class="et_pb_column et_pb_column_1_4 et_pb_column_0_tb_footer global-footer-column-1  et_pb_css_mix_blend_mode_passthrough">
                    <div class="et_pb_module et_pb_image et_pb_image_0_tb_footer et_pb_image_sticky">
                        <a href="https://www.seas.upenn.edu/" target="_blank">
                            <span class="et_pb_image_wrap ">
                                <img 
                                    loading="lazy" 
                                    width="480" 
                                    height="123" 
                                    src="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-1-seas.png"
                                    alt="Penn Engineering" 
                                    title="Penn Engineering" 
                                    srcset="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-1-seas.png 480w, https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-1-seas-300x77.png 300w" 
                                    sizes="(max-width: 480px) 100vw, 480px" 
                                    class="wp-image-3438" />
                            </span>
                        </a>
                    </div>
                    <div class="et_pb_module et_pb_image et_pb_image_1_tb_footer et_pb_image_sticky">
                        <a href="https://www.asc.upenn.edu/" target="_blank">
                            <span class="et_pb_image_wrap ">
                                <img
                                    loading="lazy"
                                    width="480"
                                    height="123"
                                    src="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-2-asc.png"
                                    alt="Penn Engineering"
                                    title="Penn Engineering"
                                    srcset="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-2-asc.png 480w, https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-2-asc-300x77.png 300w"
                                    sizes="(max-width: 480px) 100vw, 480px"
                                    class="wp-image-3440" />
                            </span>
                        </a>
                    </div>
                    <div class="et_pb_module et_pb_image et_pb_image_2_tb_footer et_pb_image_sticky">
                        <a href="https://www.wharton.upenn.edu/" target="_blank">
                            <span class="et_pb_image_wrap ">
                                <img
                                    loading="lazy"
                                    width="480"
                                    height="111"
                                    src="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-3-wharton.png"
                                    alt="Penn Engineering"
                                    title="Penn Engineering"
                                    srcset="https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-3-wharton.png 480w, https://css.seas.upenn.edu/wp-content/uploads/2022/04/newfooter-3-wharton-300x69.png 300w"
                                    sizes="(max-width: 480px) 100vw, 480px"
                                    class="wp-image-3439">
                            </span>
                        </a>
                    </div>
                </div>

            <div class="et_pb_column et_pb_column_1_4 et_pb_column_1_tb_footer global-footer-column-2  et_pb_css_mix_blend_mode_passthrough et_pb_column--with-menu">
                <div class="et_pb_module et_pb_text et_pb_text_0_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
                    <div class="et_pb_text_inner">
                        <h2>Navigate</h2>
                    </div>
                </div>
                <div class="et_pb_module et_pb_divider et_pb_divider_0_tb_footer et_pb_divider_position_ et_pb_space">
                    <div class="et_pb_divider_internal"></div>
                </div>
                <div class="et_pb_module et_pb_menu et_pb_menu_0_tb_footer footer-vertical-menu et_pb_bg_layout_light  et_pb_text_align_left et_dropdown_animation_fade et_pb_menu--without-logo et_pb_menu--style-left_aligned">
                    <div class="et_pb_menu_inner_container clearfix">
                        <div class="et_pb_menu__wrap">
                            <div class="et_pb_menu__menu">
                                <nav class="et-menu-nav">
                                    <ul id="menu-footer-menu-new" class="et-menu nav">
                                        <li id="menu-item-3425" class="et_pb_menu_page_id-2233 menu-item menu-item-type-post_type menu-item-object-page menu-item-3425">
                                            <a href="https://css.seas.upenn.edu/about/">About</a>
                                        </li>
                                        <li id="menu-item-3426" class="et_pb_menu_page_id-1732 menu-item menu-item-type-post_type menu-item-object-page menu-item-3426">
                                            <a href="https://css.seas.upenn.edu/people/">People</a>
                                        </li>
                                        <li id="menu-item-3430" class="et_pb_menu_page_id-22 menu-item menu-item-type-post_type menu-item-object-page menu-item-3430">
                                            <a href="https://css.seas.upenn.edu/research/">Research</a>
                                        </li>
                                        <li id="menu-item-3428" class="et_pb_menu_page_id-65 menu-item menu-item-type-post_type menu-item-object-page menu-item-3428">
                                            <a href="https://css.seas.upenn.edu/partnerships/">Partners</a>
                                        </li>
                                        <li id="menu-item-3429" class="et_pb_menu_page_id-52 menu-item menu-item-type-post_type menu-item-object-page menu-item-3429">
                                            <a href="https://css.seas.upenn.edu/publications/">Publications</a>
                                        </li>
                                        <li id="menu-item-3427" class="et_pb_menu_page_id-92 menu-item menu-item-type-post_type menu-item-object-page menu-item-3427">
                                            <a href="https://css.seas.upenn.edu/blog-news-events/">News</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
    <div class="et_pb_column et_pb_column_1_4 et_pb_column_2_tb_footer global-footer-column-3  et_pb_css_mix_blend_mode_passthrough">
        <div class="et_pb_module et_pb_text et_pb_text_1_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
            <div class="et_pb_text_inner">
                <h2>Contact</h2>
            </div>
        </div>
        <div class="et_pb_module et_pb_divider et_pb_divider_1_tb_footer et_pb_divider_position_ et_pb_space">
            <div class="et_pb_divider_internal"></div>
        </div>
        <div class="et_pb_module et_pb_text et_pb_text_2_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
            <div class="et_pb_text_inner">
                <p>3401 Walnut Street<br>Suite 417B<br>Philadelphia PA, 19104</p>
                <p>CSSLab@seas.upenn.edu</p>
                <p>(215) 573-7098</p></div>
        </div>
        
        <!-- <ul class="et_pb_module et_pb_social_media_follow et_pb_social_media_follow_0_tb_footer social-media-buttons clearfix  et_pb_text_align_left et_pb_bg_layout_light">
            <li class="et_pb_social_media_follow_network_0_tb_footer et_pb_social_icon et_pb_social_network_link  et-social-twitter">
                <a href="https://twitter.com/csspenn" class="icon et_pb_with_border" title="Follow on Twitter" target="_blank">
                    <span class="et_pb_social_media_follow_network_name" aria-hidden="true">Follow</span>
                </a>
            </li>
            <li class="et_pb_social_media_follow_network_1_tb_footer et_pb_social_icon et_pb_social_network_link  et-social-linkedin">
                <a href="https://www.linkedin.com/company/csslab" class="icon et_pb_with_border" title="Follow on LinkedIn" target="_blank">
                    <span class="et_pb_social_media_follow_network_name" aria-hidden="true">Follow</span>
                </a>
            </li>
         </ul> -->
    </div>

    </div>
    <div class="et_pb_row et_pb_row_1_tb_footer et_pb_equal_columns">
        <div class="et_pb_column et_pb_column_4_4 et_pb_column_4_tb_footer  et_pb_css_mix_blend_mode_passthrough et-last-child">
            <div class="et_pb_module et_pb_text et_pb_text_4_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
                <div class="et_pb_text_inner">
                    <p style="text-align: center;">
                        <a href="https://www.upenn.edu/">Penn Homepage</a>
                        <a href="https://www.upenn.edu/about/disclaimer">Disclaimer</a>
                        <a href="https://www.publicsafety.upenn.edu/contact/">Emergency Services</a>
                        <a href="https://www.upenn.edu/about/privacy-policy">Privacy Policy</a>
                        <a href="https://accessibility.web-resources.upenn.edu/get-help">Report Accessibility Issues and Get Help</a>
                        <a href="https://www.upenn.edu/about/report-copyright-infringement">Report Copyright Infringement</a>
                    </p>
                </div>
            </div>
            <div class="et_pb_module et_pb_text et_pb_text_5_tb_footer  et_pb_text_align_left et_pb_bg_layout_light">
                <div class="et_pb_text_inner">
                    <p style="text-align: center;"><em><strong></strong></em></p>
                    <p style="text-align: center;"><em><a href="https://css.seas.upenn.edu/research-assistant-positions/"><strong>Interested in working at the CSSLab?</strong> Click here to view opportunities for Penn students</a></em></p>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
</footer>

<style lang="scss">
    .et-l--footer {
        background-color: $css-lab-dark-blue;
        color: $light-grey;
    }

    .et_pb_section.et_pb_section_0_tb_footer {
        background-image: url(https://css.seas.upenn.edu/wp-content/uploads/2021/04/full-width_data-exhaust.jpg) !important;
    }

    .et_pb_section_0_tb_footer.et_pb_section {
        padding-right: 5%;
        padding-left: 5%;
        padding-top: 25px;
    }

    .et_pb_section_0_tb_footer {
        box-shadow: inset 0px 0px 1000px 1000px rgba(1,31,91,0.75);
    }

    .et_pb_section {
        position: relative;
        background-color: #fff;
        background-position: 50%;
        background-size: 100%;
        background-size: cover;
    }

    .et_pb_row_0_tb_footer,
    .et_pb_row.et_pb_equal_columns, 
    .et_pb_row_inner.et_pb_equal_columns, 
    .et_pb_section.et_pb_equal_columns > .et_pb_row {
        display: -ms-flexbox;
        display: flex;
        direction: ltr;
    }

    .et_pb_row_0_tb_footer {
        flex-direction: column;
        @media (min-width: $bp-2) {
            flex-direction: row;
        }
    }

    .et_pb_column.global-footer-column-1 {
        width: 100%;
        margin-right: 5%;

        @media (min-width: $bp-2) {
            width: 33%;
        }
    }

    .et_pb_column.global-footer-column-2 {
        width: 100%;
        margin-right: 5%;
        @media (min-width: $bp-2) {
            width: 17%;
        }
    }

    .et_pb_column.global-footer-column-3 {
        width: 100%;
        margin-right: 5%;

        @media (min-width: $bp-2) {
            width: 17%;
        }
    }

    .et_pb_image {
        max-width: 300px;
        margin-bottom: 15px;

        a {
            display: block;
            width: 100%;

            .et_pb_image_wrap {
                display: inline-block;
                width: 100%;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }

    .et_pb_text_0_tb_footer, .et_pb_text_3_tb_footer, .et_pb_text_1_tb_footer {
        padding-bottom: 15px!important;
        margin-bottom: 0px!important;
    }

    .et_pb_column_1_3 h2, 
    .et_pb_column_1_4 h2, 
    .et_pb_column_1_5 h2, 
    .et_pb_column_1_6 h2, 
    .et_pb_column_2_5 h2 {
        font-size: 23px;
    }

    .et_pb_text_inner h2 {
        font-weight: 300;
        text-transform: uppercase;
        letter-spacing: 2px;
        padding-bottom: 10px;
    }

    .et_pb_divider:before {
        content: "";
        width: 100%;
        height: 1px;
        border-top: 1px solid rgba(0,0,0,.1);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
    }

    .et_pb_divider {
        margin: 0 0 30px;
        position: relative;
    }

    .et_pb_divider_2_tb_footer:before, 
    .et_pb_divider_1_tb_footer:before, 
    .et_pb_divider_0_tb_footer:before {
        border-top-color: $css-lab-light-blue;
        border-top-width: 2px;
        width: auto;
        top: 0px;
        right: 0px;
        left: 0px;
    }

    .et_pb_divider_internal {
        display: inline-block;
        width: 100%;
    }

    .et_pb_divider_2_tb_footer, .et_pb_divider_1_tb_footer, .et_pb_divider_0_tb_footer {
        padding-bottom: 20px;
        margin-bottom: 0px!important;
        width: 15%;
    }

    .et_pb_menu--without-logo .et_pb_menu__menu>nav>ul {
        padding: 0!important;
        margin: 0;
    }

    .et_pb_menu_0_tb_footer.et_pb_menu ul li a {
        text-transform: uppercase;
        font-size: 16px;
        color: #FFFFFF!important;
        font-weight: 300;
    }

    .menu-item-object-page {
        display: flex;
        align-items: stretch;
        padding: 0 11px 11px 0;
    }

    .et_pb_text_2_tb_footer .et_pb_text_inner {
        font-weight: 300;

        p {
            padding-bottom: 10px;
        }
    }
    
    .et_pb_row_1_tb_footer {
        justify-content: center;

        .et_pb_text_4_tb_footer {
            margin: 25px 0;

            .et_pb_text_inner {
                p {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    font-size: 13px;
                    row-gap: 5px;

                    @media (min-width: $bp-2) {
                        font-size: 16px;
                    }

                    a {
                        color: $white !important;
                        font-weight: 300;
                        width: auto;
                        padding-right: 25px;
                        margin-left: 25px;
                        border-right: 2pt solid $css-lab-light-blue;
                    }

                    a:last-of-type {
                        border-right: none;
                    }
                }
            }
        }

        .et_pb_text_5_tb_footer {
            margin: 25px 0;

            .et_pb_text_inner {
                p {
                    a {
                        color: $white !important;
                        font-weight: 300;
                    }
                }
            }
        }
    
    }
</style>